import { useCallback } from 'react';
import { useAccessoryMonthlyPrices } from '@hooks/useAccessoryPrices';
import { useJourneyType } from '@hooks/useJourneyType';
import { IFeature } from '../../services';
import { IConfiguratorOption } from 'src/redux/configurator/configurator.duck.interface';

export const useOptionPrice = () => {
    const { isFinance } = useJourneyType();
    const { getFeatureMonthlyPrice, getFeatureCashPrice } = useAccessoryMonthlyPrices();
    const getPrice = useCallback(
        (item: IFeature | IConfiguratorOption) => {
            const featureMonthlyPrice = getFeatureMonthlyPrice(item);
            const totalPrice = getFeatureCashPrice(item);
            const monthlyPrice = featureMonthlyPrice?.price ?? featureMonthlyPrice?.defaultPrice;

            return { monthlyPrice, totalPrice };
        },
        [isFinance, getFeatureCashPrice, getFeatureMonthlyPrice]
    );

    return { getPrice };
};
